var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"template"},[_c('text',{attrs:{"x":"50%","y":"40%"}},[_vm._v("New")])])}
var staticRenderFns = []

export { render, staticRenderFns }